module.exports = __webpack_public_path__ + "static/media/WoodConnectionType1.6eee8c86.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/WoodConnectionType1.png
// module id = 1186
// module chunks = 0